// The Track Title filter shows at production level only (FR-LPAY-18); on a track's tab the drawer
// offers the other filters (QA pass on QW-420).
export function showsTrackFilter(payload?: { isTrack?: boolean } | null): boolean {
  return !payload?.isTrack;
}
